import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, Collapse, IconButton } from "@mui/material";
import { closeDialogXIcon } from "../../common/icons";
import { useTranslation } from "../../localization/useTranslation";
import { CvrResultViewModel } from "./CvrSelector.types";

export interface ICvrSelectorResultProps {
    selectedResult?: CvrResultViewModel;
    clearSelectedResult: () => void;
}

function CvrSelectorResult(props: ICvrSelectorResultProps) {
    const { translateString } = useTranslation();

    function getValue(label: string, value?: string) {
        if (!value) {
            return undefined;
        }

        return (
            <DotLegalHeader headerStyle={"small"}>
                {label}:{" "}
                <Box component={"span"} sx={{ fontWeight: 400 }}>
                    {value}
                </Box>
            </DotLegalHeader>
        );
    }

    return (
        <>
            <Collapse in={props.selectedResult !== undefined}>
                <Box sx={(theme) => ({ marginTop: 2, backgroundColor: theme.palette.grey[100], padding: 1.5, borderRadius: "15px" })}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <DotLegalHeader headerStyle={"small"} fontWeight={400}>
                            {translateString("followingDataWillBeImported")}
                        </DotLegalHeader>
                        <Box
                            sx={{
                                "& svg": {
                                    width: 12,
                                    height: 12,
                                },
                            }}
                        >
                            <IconButton
                                onClick={() => {
                                    props.clearSelectedResult();
                                }}
                            >
                                {closeDialogXIcon}
                            </IconButton>
                        </Box>
                    </Box>
                    {getValue(translateString("name"), props.selectedResult?.name)}
                    {getValue(translateString("companyRegistrationNumber"), props.selectedResult?.companyRegistrationNumber.toString())}
                    {getValue(translateString("address"), props.selectedResult?.address)}
                    {getValue(translateString("zipCodeAndCity"), props.selectedResult?.zipCode + " " + props.selectedResult?.city)}
                    {getValue(translateString("description"), props.selectedResult?.description)}
                    {getValue(translateString("website"), props.selectedResult?.website)}

                    <DotLegalHeader fontStyle="italic" fontWeight={400} headerStyle="extraSmall" marginBottom={0.5}>
                        {translateString("cvrInfo")}
                    </DotLegalHeader>
                </Box>
            </Collapse>
        </>
    );
}

export default CvrSelectorResult;
